import { API } from '@providers/ApiInterceptorProvider/useApiInterceptor';
import { IAddressListResponse } from './types';

export const addressApi = {
  getAddressesByPostcode: async (postcode: string) => {
    try {
      const response = await API.get<IAddressListResponse>(`/address-lookup?postcode=${postcode}`);

      return { status: response.status, data: response.data };
    } catch (err: any) {
      console.error(err);
      return { status: err.status, data: null };
    }
  },
};
